import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { IconButton, InputLabel } from '@material-ui/core';
import { useField, useFormikContext } from 'formik';
import DateFnsUtils from '@date-io/date-fns';
import tr from 'date-fns/locale/tr';

// icons
import ClearIcon from '@material-ui/icons/Clear';
import { Today } from '@material-ui/icons';

// local imports
import { FormatUtils } from 'app/utils';

function CustomDateTimePicker({
  name,
  label = 'Tarih Seç',
  placeholder = 'Tarih seç',
  value,
  onChange,
  ...otherProps
}) {
  const [field, meta] = useField(name);
  const { values, setFieldValue } = useFormikContext();

  const handleChange = e => {
    setFieldValue(name, e);
    onChange?.({ name, value: FormatUtils.convertPostDateWithHours(e) });
  };

  const handleClear = e => {
    e.stopPropagation();
    handleChange(null);
  };

  const DateTimePickerProps = {
    ...field,
    ...otherProps,
    value: values[name] || null,
    onChange: handleChange,
    variant: 'inline',
    size: 'small',
    className: 'w-full',
    format: 'dd/MM/yyyy HH:mm',
    inputVariant: 'outlined',
    autoOk: true,
    placeholder,
    ampm: false,
    hideTabs: true,
    minutesStep: 5,
    PopoverProps: {
      className: 'w-1/2'
    },
    InputProps: {
      endAdornment: (
        <>
          {values[name] ? (
            <IconButton size="small" onClick={handleClear}>
              <ClearIcon color="error" />
            </IconButton>
          ) : (
            <IconButton size="small">
              <Today color="action" />
            </IconButton>
          )}
        </>
      )
    }
  };

  if (meta && meta.touched && meta.error) {
    DateTimePickerProps.error = true;
    DateTimePickerProps.helperText = meta.error;
  }

  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={tr}>
        <InputLabel className="mb-8 text-gray-700 font-semibold">{label}</InputLabel>
        <DateTimePicker {...DateTimePickerProps} />
      </MuiPickersUtilsProvider>
    </>
  );
}

export default CustomDateTimePicker;
